import config from "../config";

export const API_VER = "v1";

const originUrl = config.apiGateway.API_SERVER_URL;

export const API_BASE = `${originUrl}/api/${API_VER}`;

const auth = {
  login: "/auth/token",
  userInfo: `/account/get`,
  forgotPassword: "/auth/forgot",
};

const users = {
  search: "admin/account/search",
  getUserById: "admin/account/get",
  updateUser: "admin/account/update",
  getFitnessProfileByUserId: "admin/fitnessProfile/get",
  deleteUser: "admin/account/delete",
};

const trainers = {
  search: "account/trainer/search",
  createTrainer: "admin/account/trainer/create",
};

const exercises = {
  search: "exercise/search",
  createExercise: "admin/exercise/create",
  updateExercise: "admin/exercise/update",
  getExercise: "exercise/get",
  deleteExercise: "admin/exercise/delete",
  getExercisesByid: "exercise/many",
};

const files = {
  getPresignedUrl: "files/presigned-url",
};

const trainingPrograms = {
  getTrainingProgram: "trainingProgram/get",
  createTrainingProgram: "admin/trainingProgram/create",
  updateTrainingProgram: "admin/trainingProgram/update",
  deleteTrainingProgram: "admin/trainingProgram/delete",
  search: "admin/trainingProgram/paginate/accounts",

  addWorkout: "admin/trainingProgram/workout/add",
  removeWorkout: "admin/trainingProgram/workout/remove",
  enableWorkout: "admin/trainingProgram/workout/enable",
  disableWorkout: "admin/trainingProgram/workout/disable",
  moveWorkout: "admin/trainingProgram/workout/move",
  copyWorkout: "admin/workout/copy",

  getActiveUsers: "admin/trainingProgram/accounts",

  getGroups: "admin/trainingProgram/search/groups",
};

const workouts = {
  getWorkout: "workout/get",
  createWorkout: "admin/workout/create",
  updateWorkout: "admin/workout/update",
  deleteWorkout: "admin/workout/delete",
  search: "workout/search",
};

const vods = {
  getVod: "vod/get",
  createVod: "admin/vod/create",
  updateVod: "admin/vod/update",
  deleteVod: "admin/vod/delete",
  search: "vod/search",
};

const recipes = {
  getRecipe: "recipe/get",
  createRecipe: "admin/recipe/create",
  updateRecipe: "admin/recipe/update",
  deleteRecipe: "admin/recipe/delete",
  search: "recipe/search",
};

const journals = {
  getActiveTrainingPrograms: "admin/journal/program/active",
  getUnfinishedTrainingPrograms: "admin/journal/program/unfinished",
  getFinishedTrainingPrograms: "admin/journal/program/finished",
};

const dashboard = {
  getDashboardStats: "stats/get",
  getWorkoutsTraineeCounts: "stats/workouts/counts",
  getTrainingProgramsTraineeCounts: "stats/trainingPrograms/counts",
  getRevenues: "stats/revenues/search",
};

const AXIOS_ROUTES = {
  auth,
  users,
  trainers,
  exercises,
  files,
  trainingPrograms,
  workouts,
  vods,
  recipes,
  journals,
  dashboard,
};

export default AXIOS_ROUTES;
